<template>
  <ui-component-modal
    modalTitle="Add image"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="saveSpaceImage"
    :disableSaveButton="disableSaveButton"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template v-slot:content>
      <div class="columns is-mobile is-multiline is-vcentered">
        <div class="column is-7">
          <ImageCropper
            ref="imageCropper"
            :aspectRatio="4/3"
            :guides="false"
            :viewMode="3"
            previewContainer=".imagePreview"
            @callbackImageChosen="val => { newImageChosen = val }"
            @errorCallbackInvalid="val => { hasImageError = val }"
            aspectRatioCssClass="is-4by3"
          />
        </div>
        <div class="column is-5">
          <div class="wrapper-previews">
            <div class="imagePreview has-background-grey-light"></div>
          </div>
        </div>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { cleanSource } from '@/utils/objectHelper.js'
import spaceProvider from '@/providers/space'
import uploadProvider from '@/providers/upload'

const ImageCropper = () => import('@/components/UI/Components/ImageCropper')

export default {
  components: {
    ImageCropper,
  },

  props: {
    meetingtypeId: {
      default: 0,
      type: Number,
    },

    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isSavingError: false,
      isSavingSuccess: false,
      isSaving: false,
      mSpace: null,
      spaceImage: '',
      newImageChosen: false,
      hasImageError: false
    }
  },

  computed: {
    ...mapState('spaceStore', ['space']),

    disableSaveButton() {
      return this.isSaving || !this.newImageChosen || this.hasImageError
    },
  },

  created() {
    this.mSpace = cleanSource(this.space)
  },

  methods: {
    ...mapMutations('spaceStore', ['setSpace']),

    async saveSpaceImage() {
      if (this.disableSaveButton) { return }
      this.isSaving = true

      try {
        const NEW_IMAGE = this.$refs.imageCropper.getCroppedCanvas()
        let responseImageUpload = await uploadProvider.methods.locationImage(this.space.LocationId, NEW_IMAGE)

        if (responseImageUpload.status === 200) {
          this.mSpace.Images.push({
            Id: 0,
            SpaceId: this.space.Id,
            IsDefault: this.mSpace.Images.length === 0,
            MeetingtypeId: this.meetingtypeId,
            Image: responseImageUpload.data,
          })
          let saveSpaceImageResponse = await spaceProvider.methods.updateSpace(this.mSpace)
          this.isSavingSuccess = true

          this.setSpace(saveSpaceImageResponse.data)

          let t = setTimeout(() => {
            this.onClickCancel()
            clearTimeout(t)
          }, 2000)
        }
      } catch (error) {
        this.isSaving = false
        this.isSavingError = true
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.wrapper-previews
  display: flex
  flex-grow: 1
  .imagePreview
    overflow: hidden
    aspect-ratio: 4/3
    &:nth-child(1)
      max-width: 80%
      width: 100%
</style>